export default {
  setInitData (state, workloads) {
    state.masterWorkloads = workloads
  },
  setChangeLogs (state, logs) {
    state.logRecords = logs
  },
  setLogsShown (state, show) {
    state.logsShown = show
  },
  setLoadingLogs (state, show) {
    state.loadingLogs = show
  },
  clearLogs (state) {
    state.logRecords = []
  },
  setCurrentAwsInfo (state, data) {
    let { AWSInfo_id, AWS_Approval, Extract, Project_Id, ...fromAwsInfoData } = data
    state.changeFrom = fromAwsInfoData
  },
  setCurrentOppregQuestionnaire (state, data) {
    state.questionnaireChangeFrom = data
  },

  setChangedToAwsInfo (state, data) {
    let { AWSInfo_id, AWS_Approval, Extract, Project_Id, ...toAwsInfoData } = data
    state.questionnaireChangeTo = toAwsInfoData
  },

  setAwsInfoId (state, data) {
    state.workload.aws.AWSInfo_id = data
  },
  setAwsStatus (state, data) {
    
    state.isAwsInfoExist = data
  },
  refreshMasterWorkloads (state, data) {
    let recordToBeUpdated = state.masterWorkloads.findIndex(res => res.Project_Id === data.Project_Id)
    state.masterWorkloads.splice(recordToBeUpdated, 1, { ...state.masterWorkloads[recordToBeUpdated], Workload_Status: data.Workload_Status })
  },
  reloadDocuments (state, workload) {
    state.workload.uploads = workload
  },

  setUploadingState (state, loading) {
    state.upload = { ...state.upload, loading: loading }
  },

  setUploadDialogState (state) {
    state.upload = { ...state.upload, dialog: true }
  },

  // updateoppnum (state, data) {
  //   state.workload.questionaire.Opportunity_Number = data
  // },

  clearFileUpload (state) {
    state.upload = {
      File: null,
      fileBase: null,
      filename: null,
      uploadedBy: null,
      AWS_Info_Id: null,
      loading: false,
      dialog: false
    }
  },

  loadWorkloadData (state,workload) {
    state.newWorkload = {
      oppproject: workload.questionaire != null ? workload.questionaire : state.newWorkload.oppproject, 
      wlqa: workload.questionnaire != null ? workload.questionnaire : state.newWorkload.wlqa
    }
  },

  resetLoadWorkloadData (state,workload) {
    state.newWorkload.wlqa =  {
      Id: null,
      Project_Id: null,
      WL_Q1A: null,
      WL_Q2A: null,
      WL_Q3A: null,
      WL_Q4A: null,
      WL_Q5A: null,
      WL_Q6A: null,
      Attested_By: null,
      DXC_Services: null,
      WL_Q7A: '[]',
      WL_Q8A: null,
      WL_Q9A: null,
      WL_Q10A: null
    }
  },

  loadOppregProject (state, workload) {

    let workloadType
    if (workload.questionnaire.Q7 === 'Y') {
      workloadType = 'Transfer'
      
    } else {
      switch (workload.questionnaire.Pricing_Tier_Qualification) {
        case '1':
          workloadType = 'PPA'
          break;
        case '2':
          workloadType = 'SPP'
          break;
        case '3':
          workloadType = 'SPP'
          break;
        default:
          break;
      }
    }
    // if (
    //   workload.questionnaire.WL_Q1A === "Y" ||
    //   workload.questionnaire.WL_Q2A === "Y" ||
    //   (workload.questionnaire.WL_Q3A === "Y" &&
    //    workload.questionnaire.WL_Q4A === "Y" &&
    //    workload.questionnaire.WL_Q5A === "N" &&
    //    workload.questionnaire.WL_Q6A === "N")
    // ) {
    //   workloadType = 'PPA'
    // } else if (
    //   workload.questionnaire.WL_Q3A === "N" ||
    //   workload.questionnaire.WL_Q4A === "N" ||
    //   workload.questionnaire.WL_Q5A === "Y" ||
    //   workload.questionnaire.WL_Q6A === "Y"
    // ) {
    //   workloadType = 'SPP'
    // }
    state.workload = {
      workloadType: workloadType,
      opportunity: workload.opportunity != null ? workload.opportunity : state.workload.opportunity,
      account: workload.account != null ? workload.account : state.workload.account,
      requestor: workload.requestor != null ? workload.requestor : state.workload.requestor,
      contact: workload.contact != null ? workload.contact : state.workload.contact,
      questionaire: workload.questionaire != null ? workload.questionaire : state.workload.questionaire,
      wlqa: workload.questionnaire !=null ? workload.questionnaire : state.workload.questionnaire,
      aws: workload.aws,
      header: workload.header !== null ? workload.header : state.workload.header,
      uploads: workload.uploads !== null ? workload.uploads : state.workload.uploads
    }
  if (workload.aws.OppReg_Status === null)
  state.workload.aws.OppReg_Status = workload.header.OppReg_Status
    
  },
  setWorkloadType (state, type) {

    state.newWorkload = {
      ...state.newWorkload,
      workloadType: type
    }

    state.workload = {
      ...state.workload,
      workloadType: type
    }
  },

  addtoExport (state, workload) {

    // check if opx is on workload title
    let partnerProjectTitle = workload.questionaire.Workload_Title.indexOf(workload.opportunity.Opportunity_Id) === -1 ? `${workload.opportunity.Opportunity_Id}: ${workload.questionaire.Workload_Title}` : workload.questionaire.Workload_Title

    state.checkedWorkload = {
      Project_Id: workload.questionaire.Project_Id,
      Registration_Id: workload.questionaire.Registration_Id,
      Workload_Title: workload.questionaire.Workload_Title,
      isChecked: true
    }
    state.checkedWorkloads.push(state.checkedWorkload)
    // Update AWS Extract
    state.exportWorkload = {
      Customer_Company_Name: workload.opportunity.Customer_Name != null ? workload.opportunity.Customer_Name : '-',
      Partner_Project_Title: partnerProjectTitle !== '' ? partnerProjectTitle : '-',
      Project_Description: workload.questionaire.Workload_Description !== '' ? workload.questionaire.Workload_Description : '-',
      Expected_Monthly_AWS_Revenue: workload.questionaire.Projected_Monthly_Spend !== '' ? workload.questionaire.Projected_Monthly_Spend : '-',
      Industry_Vertical: workload.opportunity.IndustryVertical != null ? workload.opportunity.IndustryVertical : '-',
      Country: workload.header.Country !== '' ? workload.header.Country : '-',
      Postal_Code: workload.account.Customer_PC !== '' ? workload.account.Customer_PC : '-',
      Website: workload.account.Customer_URL !== '' ? workload.account.Customer_URL : '-',
      Use_Case: 'Migration / Database Migration',
      Target_Close_Date: workload.opportunity.SignDate !== '' ? workload.opportunity.SignDate : '-',
      Partner_Primary_Need_from_AWS: 'Technical Consultation',
      Customer_First_Name: workload.contact.Contact_First_Name !== '' ? workload.contact.Contact_First_Name.replace(/,/g, '') : '-',
      Customer_Last_Name: workload.contact.Contact_Last_Name !== '' ? workload.contact.Contact_Last_Name : '-',
      Customer_Title: workload.contact.Contact_Title !== '' ? workload.contact.Contact_Title : 'N/A',
      Customer_Phone: workload.contact.Contact_Phone !== '' ? workload.contact.Contact_Phone : '-',
      Customer_Email: workload.contact.Contact_Email !== '' ? workload.contact.Contact_Email : '-',
      AWS_Account_ID: null,
      Additional_Comments: '',
      Other_Industry: workload.opportunity.IndustryVerticalOther != null ? workload.opportunity.IndustryVerticalOther : '-',
      State_Province: workload.account.Customer_State != null ? workload.account.Customer_State : '-',
      Street_Address: workload.account.Customer_Address != null ? workload.account.Customer_Address : '-',
      City: workload.account.Customer_City != null ? workload.account.Customer_City : '-',
      Sub_Use_Case: '',
      Is_this_for_Resell: 'None',
      Competitive_Tracking: '',
      Other_Competitors: 'None',
      Campaign_Name: workload.questionaire.Campaign_Name !== '' ? workload.questionaire.Campaign_Name : '-',
      Contract_Vehicle: workload.opportunity.IndustryVertical === 'Government' || workload.opportunity.IndustryVertical === 'Education' ? 'Unknown' : '',
      Public_Tender_Solicitation_No: workload.opportunity.IndustryVertical === 'Government' || workload.opportunity.IndustryVertical === 'Education' ? 'Unknown' : '',
      Is_this_for_Marketplace: '',
      Marketing_Development_Funded: '',
      Did_an_AWS_Account_Rep_for_this_opportunity: '',
      Primary_Sales_Contact_First_Name: workload.contact.Contact_First_Name !== '' ? workload.contact.Contact_First_Name.replace(/,/g, '') : '-',
      Primary_Sales_Contact_Last_Name: workload.contact.Contact_Last_Name !== '' ? workload.contact.Contact_Last_Name : '-',
      Primary_Sales_Contact_Phone: workload.contact.Contact_Phone !== '' ? workload.contact.Contact_Phone : '-',
      Primary_Sales_Contact_Email: workload.contact.Contact_Email !== '' ? workload.contact.Contact_Email : '-',
      Primary_Contact_Title: '',
      Does_this_opportunity_include_managed_services: workload.questionaire.DXC_Managed_Services
    }

    // AGAM 1573 - remove pricing tier in the desc
    // let projectDescription = workload.questionaire.Workload_type + ":\r\n ";
    let projectDescription = ""
    // New questions will always have value to this field, and old questions default value is None 
    if (workload.questionaire.Q1 !== 'None') {
      // **** NEW AWS EXTRACT FORMAT *******//
      let q1, q2, q3, q8, q9, q10
      q1 = "1. What are the client's pain points and business objectives? What is the plan for AWS in support of the client's desired outcomes?"
      q2 = "2. What is the role of DXC in this project? Which Software applications  and/or tools will support the solution?"
      q3 = "3. What specific client department or subsidiary is DXC working with?"
      q8 = "8. Will the client require access to DXC's AWS login credentials, the AWS Management Console or AWS resources, e.g. S3 storage or EC2 instances? If YES, then workload qualifies for SPP and there is no need for questions 9 and 10."
      q9 = "9. Will the AWS resources be used for a SaaS or PaaS solution delivered by DXC? If YES, then workload qualifies for PPA and there is no need for question 10."
      q10 = "10. For existing non-AWS workloads, has DXC been providing managed services for the workload(s) since September 1, 2018? If YES, then workload qualifies for PPA."

      let question1, question2, question3, question4, question5, question6, question8, question9, question10
      question1 = workload.wlqa.Q1 !== '' ? q1 +': '+ workload.questionaire.Q1 + " \n\n" : ''
      question2 = workload.wlqa.Q2 !== '' ? q2 +': '+ workload.questionaire.Q2 + " \n\n" : ''
      question3 = workload.wlqa.Q3 !== '' ? q3 +': '+ workload.questionaire.Q3 + " \n\n" : ''  
      question8 = workload.wlqa.Q8 !== '' ? q8 +': '+ workload.questionaire.Q8 + " \n\n" : ''
      question9 = workload.wlqa.Q9 !== '' ? q9 +': '+ workload.questionaire.Q9 + " \n\n" : ''
      question10 = workload.wlqa.Q10 !== '' ? q10 +': '+ workload.questionaire.Q10 + " \n\n" : ''  

      projectDescription += question1 + question2 + question3

    } else {
      // **** OLD AWS EXTRACT FORMAT *******//
      let q1,q2,q3,q4,q5,q6
      q1 = 'Will the AWS cloud environment be used for DXC internal use only, such as a DXC application to which DXC clients do not have access?'
      q2 = 'Will the cloud environment be used for a SaaS or other software solution where DXC`s client will have access only to the application and not to the AWS cloud environment?'
      q3 = 'Are you moving an existing workload into an AWS cloud environment?'
      q4 = 'Has DXC been managing the existing workload beginning on or before September 1, 2018 up until the present (for example, is DXC hosting the workload in a DXC center or providing application services for the workload?)'
      q5 = "Has the workload been hosted on AWS before now?"
      q6 = "Will DXC's client expectation be to have ongoing root/administrative access to the AWS virtual machines (eg. are we selling DXC Managed Services for AWS Services" 

      let question1, question2, question3, question4, question5, question6
      question1 = workload.wlqa.WL_Q1A !== '' ? q1 +': '+ workload.wlqa.WL_Q1A + " \n\n" : ''
      question2 = workload.wlqa.WL_Q2A !== '' ? q2 +': '+ workload.wlqa.WL_Q2A + " \n\n" : ''
      question3 = workload.wlqa.WL_Q3A !== '' ? q3 +': '+ workload.wlqa.WL_Q3A + " \n\n" : ''
      question4 = workload.wlqa.WL_Q4A !== '' ? q4 +': '+ workload.wlqa.WL_Q4A + " \n\n" : ''
      question5 = workload.wlqa.WL_Q5A !== '' ? q5 +': '+ workload.wlqa.WL_Q5A + " \n\n" : ''
      question6 = workload.wlqa.WL_Q6A !== '' ? q6 +': '+ workload.wlqa.WL_Q6A : '' 

      projectDescription += question1 + question2 + question3 + question4 + question5 + question6
    }

    const solutionOfferedMapping = {
      'DXC Global Infrastructure Services (GIS)': 'S-0069093',
      'DXC Consulting & Engineering Services (CES)': 'S-0069092',
      'DXC Insurance Software Business (ISB)': 'S-0069088'
    }
    
    state.newExportWorkload = {
      Customer_Company_Name: workload.opportunity.Customer_Name != null ? workload.opportunity.Customer_Name : '-',
      Partner_Project_Title: partnerProjectTitle,
      // Project_Description: workload.workloadType +" \r\n "+ question1 + question2 + question3 + question4 + question5 + question6, 
      Project_Description: projectDescription,
      Expected_Monthly_AWS_Revenue: workload.questionaire.Q4, 
      Industry_Vertical: workload.opportunity.IndustryVertical,
      NatSec: workload.opportunity.NatSec,
      Country: workload.header.Country,
      Postal_Code: workload.account.Customer_PC,
      Website: workload.account.Customer_URL,
      Use_Case: 'Migration / Database Migration',
      Target_Close_Date: workload.opportunity.SignDate,
      Partner_Primary_Need_from_AWS: 'Co-Sell - Deal Support', 
      Solution_Offered: solutionOfferedMapping[workload.questionaire.Solution_Business_Segment],
      Other_Solution_Offered: '',
      Opportunity_Type: 'Net New business',
      Sales_Activities: 'Initialized discussions with customer',
      AWS_Products: '',
      Delivery_Model: 'Managed Services',
      Opportunity_From_Marketing: workload.questionaire.Campaign_Name.includes('Glacier') ? 'Yes' : 'No',
      Marketing_Development_Funded: workload.questionaire.Campaign_Name.includes('Glacier') ? 'No' : '',
      Customer_First_Name: workload.contact.Contact_First_Name !== '' ? workload.contact.Contact_First_Name.replace(/,/g, '') : '-', 
      Customer_Last_Name: workload.contact.Contact_Last_Name !== '' ? workload.contact.Contact_Last_Name : '-',
      Customer_Title: workload.contact.Contact_Title !== '' ? workload.contact.Contact_Title : 'N/A',
      Customer_Phone: workload.contact.Contact_Phone !== '' ? workload.contact.Contact_Phone : '-',
      Customer_Email: workload.contact.Contact_Email !== '' ? workload.contact.Contact_Email : '-',
      AWS_Account_ID: workload.aws.AWSInfo_Id ,
      Additional_Comments: '',
      Industry_Other: workload.opportunity.IndustryVerticalOther,
      State_Province: workload.account.Customer_State, 
      Street_Address: workload.account.Customer_Address,
      City: workload.account.Customer_City,
      // Sub_Use_Case: '', 
      Competitive_Tracking: 'No Competition',
      Other_Competitors: 'None',
      // Campaign_Name: workload.questionaire.Campaign_Name.includes('Glacier') ? 'Project Glacier' : '',
      Campaign_Name: (function () {
        const raw = (workload.questionaire && workload.questionaire.Campaign_Name) ? workload.questionaire.Campaign_Name : ''
        const items = Array.isArray(raw) ? raw : (raw ? String(raw).split(',') : [])
        const tokens = items.map(i => String(i).trim().toUpperCase())
        const parts = []
        if (tokens.some(t => t.includes('GLACIER'))) parts.push('Project Glacier')
        if (tokens.some(t => t.includes('APN BOX'))) parts.push('APN BOX')
        return parts.length ? parts.join(','.toString()) : ''
      })(),
      // Campaign_Name: workload.questionaire.Campaign_Name.includes('Glacier') ? 'Project Glacier' : '',
      // Contract_Vehicle: workload.opportunity.IndustryVertical === 'Government' || workload.opportunity.IndustryVertical === 'Education' ? 'Unknown' : '',
      // Public_Tender_Solicitation_No: workload.opportunity.IndustryVertical === 'Government' || workload.opportunity.IndustryVertical === 'Education' ? 'Unknown' : '',
      Is_this_for_Marketplace: '',
      Did_an_AWS_Account_Rep: '',
      Primary_Sales_Contact_First_Name: workload.contact.Contact_First_Name !== '' ? workload.contact.Contact_First_Name.replace(/,/g, '') : '-', 
      Primary_Sales_Contact_Last_Name: workload.contact.Contact_Last_Name !== '' ? workload.contact.Contact_Last_Name : '-',
      Primary_Sales_Contact_Phone: workload.contact.Contact_Phone !== '' ? workload.contact.Contact_Phone : '-',
      Primary_Sales_Contact_Email: workload.contact.Contact_Email !== '' ? workload.contact.Contact_Email : '-',
      Primary_Contact_Title: '',
      If_Other_please_describe_your_needs: '',
      Partner_CRM_Unique_Identifier: '',
      Consent_to_Limit_Visibility: 'No'
    }
    state.exportWorkloads.push(state.exportWorkload)
    state.newExportWorkloads.push(state.newExportWorkload) 
  },
  removetoExport (state, workload) {
    let currentRegId = workload.questionaire.OppReg_Id
    let currentProjectTitle = workload.questionaire.Workload_Title
    let partnerProjTitle = currentRegId+' : '+currentProjectTitle
    let dataExist = state.exportWorkloads.findIndex(res =>
      res.Partner_Project_Title === currentProjectTitle)
    
    if (dataExist !== -1) {
      state.exportWorkloads.splice(dataExist, 1)
    }
    let isWorkloadChecked = state.checkedWorkloads.findIndex(res => res.Workload_Title === currentProjectTitle)
    if (isWorkloadChecked !== -1) {
      state.checkedWorkloads.splice(isWorkloadChecked, 1)
    }

    //NEW AWS EXTRACT
    let partnerProjTitle1 = currentRegId+' : '+currentProjectTitle
    let dataExist1 =state.newExportWorkloads.findIndex(res =>
      res.Partner_Project_Title === partnerProjTitle1)
    if (dataExist1 !== -1) {
      state.newExportWorkloads.splice(dataExist, 1)
    }
    let isWorkloadChecked1 = state.checkedWorkloads.findIndex(res => res.Workload_Title === currentProjectTitle)
    if (isWorkloadChecked1 !== -1) {
      state.checkedWorkloads.splice(isWorkloadChecked, 1)
    }
  },
  clearAwsExport (state, workload) {
    state.exportWorkloads = []
    state.newExportWorkloads = []
    state.checkedWorkloads = []
  },
  loadUpdatedAWS (state, workload) {
    state.workloads['aws'] = workload
  },
  clearAWSInfoData (state) {
    state.workloads['aws'] = {
      OppReg_Status: null,
      AWS_SalesRep_Name: null,
      AWS_SalesRep_eMail: null,
      AWS_Approval: null,
      AWS_Notes: null,
      AWS_Date_Approved: null,
      AWS_Use_Case: null,
      AWS_Sub_Use_Case: null,
      AWS_Partner_Primary: null,
      AWS_Reseller: null,
      AWS_Competitive_Tracking: null,
      AWS_Other_Competitors: null
    }
  },
  loadingEmail (state, loading) {
    state.dialogEmail = {
      ...state.dialogEmail,
      loading
    }
  },
  loadEmailTemplate (state, data) {
    state.dialogEmail = { 
      ...state.dialogEmail, 
      ...data
    }
  },
  // loadEmailTemplate (state, data) {
  //   state.dialogEmail = { 
  //     ...state.dialogEmail, 
  //     templateEmail: data.body, 
  //     emailSubjectType: 
  //     data.subject, 
  //     Contact_Email: data.to,
  //     emailRecipients: [data.to],
  //     email_template: data.email_template 
  //   }
  // },
  sendingEmailTemplate (state, loading) {
    state.sendHandlerLoading = loading
  },
  clearTemplates (state) {
    state.dialogEmail = {
      ...state.dialogEmail,
      sendLabel: 'Send Email',
      cancelLabel: 'Cancel',
      Contact_Email: null,
      emailRecipients: [],
      emailSubjectType: null,
      email_template: null,
      templateEmail: null,
      Notes: null
    }
  },
  openDialogEmail (state, data) {
    state.dialogEmail = { ...state.dialogEmail, ...data }
  },
  
  setLoadingRequest: (state, loading) => {
    state.loadingRequest = loading
  },
  // GENERAL REPORTING
  setNotification (state, data) {
    state.newOppRegistration.withError = data
  },

  updateOppregAdminList (state, workload) {
    let recordBeUpdatedIndex = state.masterWorkloads.findIndex(record => record.OppReg_Id === workload.opportunity.Opportunity_Id)
    if (recordBeUpdatedIndex !== -1) {
      state.masterWorkloads.splice(recordBeUpdatedIndex, 1, { ...state.masterWorkloads[recordBeUpdatedIndex] })
    }

  },

  setWorkloadDataList (state, workloads) {
    // state.workloadList = workloads
    state.workloadLists1= []

    if (state.adminReportNextPageKey) {
      state.adminReportWorkloadList = [
        ...state.adminReportWorkloadList,
        ...workloads
      ]
    } else {
      state.adminReportWorkloadList = workloads
    }
    workloads.forEach(function (workload, index) {
      
      if(workload.Legacy === 'N') {

        //Project Description: Concatenation of three new questions from oppreg questionnaire
        //Expected  Monthly Aws Revenue : Questionnaire, Step 2, Monthly Estimated AWS Spend
        let q1,q2,q3,q4,q5,q6
        q1 = 'Will the AWS cloud environment be used for DXC internal use only, such as a DXC application to which DXC clients do not have access?'
        q2 = 'Will the cloud environment be used for a SaaS or other software solution where DXC`s client will have access only to the application and not to the AWS cloud environment?'
        q3 = 'Are you moving an existing workload into an AWS cloud environment?'
        q4 = 'Has DXC been managing the existing workload beginning on or before September 1, 2018 up until the present (for example, is DXC hosting the workload in a DXC center or providing application services for the workload?)'
        q5 = "Has the workload been hosted on AWS before now?"
        q6 = "Will DXC's client expectation be to have ongoing root/administrative access to the AWS virtual machines (eg. are we selling DXC Managed Services for AWS Services"
    
        let workloadType, question1, question2, question3, question4, question5, question6
        workloadType = workload.Workload_type !=='None' ? workload.Workload_type +";" : ''
        question1 = workload.WL_Q1A !== 'None' ? q1 +': '+ workload.WL_Q1A + " ;" : ''
        question2 = workload.WL_Q2A !== 'None' ? q2 +': '+ workload.WL_Q2A + " ;" : ''
        question3 = workload.WL_Q3A !== 'None' ? q3 +': '+ workload.WL_Q3A + " ;" : ''
        question4 = workload.WL_Q4A !== 'None' ? q4 +': '+ workload.WL_Q4A + " ;" : ''
        question5 = workload.WL_Q5A !== 'None' ? q5 +': '+ workload.WL_Q5A + " ;" : ''
        question6 = workload.WL_Q6A !== 'None' ? q6 +': '+ workload.WL_Q6A : '' 

        state.report = {
          ...state.report,
          DXC_Opportunity_Region: workload.Customer_Region,
          DXC_Opportunity_Company_Name: workload.OI_Customer_Name,
          Partner_Project_Title: workload.SFDC_Id +' : '+ workload.Workload_Title,
          Project_Description: workloadType + question1 + question2 + question3 + question4 + question5 + question6, 
          Expected_Monthly_AWS_Revenue: workload.WL_Q10A,
          DXC_Industry: workload.IndustryVertical,
          Customer_Country: workload.Country,
          Customer_State: workload.Customer_State,
          Customer_Street_Address: workload.Customer_Address,
          Customer_City: workload.Customer_City,
          Customer_Postal_Code: workload.Customer_PC,
          Customer_Primary_Website_URL: workload.Customer_URL,
          Target_Close_Date: workload.SignDate,
          Saas: workload.WL_Q2A,
          Attestation:workload.Attested_By,
          Approved_Tier:workload.Workload_Status,
          Date_Approved:workload.AWS_Date_Approved,
          SFDC_Status:workload.SFDC_Sales_Stage, // SFDC Sales Stage
          Notes:workload.AWS_Notes,
          Creator_Name: workload.Contact_FullName,
          Creator_Email:workload.Contact_Email,
          Date_Created:workload.Date_Created
        }
        let workloadStatus = [
           'Approved - Tier 1 23% - PPA'
          ,'Approved - Tier 3 12%'
          ,'Approved - Tier 2 - Custom EDP'
          ,'Disqualified - AWS forecast conflict'
          ,'Shareshift'
          ,'Disqualified - Incomplete'
          ,'Disqualified - No AWS scope'
        ]
        if(!workloadStatus.includes(workload.Workload_Status)){
          state.report = {
            ...state.report, 
            Date_Approved: ''
          }
        }
      
      } else {
        // LEGACY //
        state.report = {
          ...state.report,
          DXC_Opportunity_Region: workload.Customer_Region,
          DXC_Opportunity_Company_Name: workload.OI_Customer_Name,
          Partner_Project_Title: workload.SFDC_Id +' : '+ workload.Workload_Title,
          Project_Description: workload.OpportunityDescription, 
          Expected_Monthly_AWS_Revenue: workload.Projected_Monthly_Spend,
          DXC_Industry: 'Other',
          Customer_Country: workload.Country,
          Customer_State: workload.Customer_State,
          Customer_Street_Address: workload.Customer_Address,
          Customer_City: workload.Customer_City,
          Customer_Postal_Code: workload.Customer_PC,
          Customer_Primary_Website_URL: workload.Customer_URL,
          Target_Close_Date: workload.SignDate,
          Saas: workload.WL_Q2A,
          Attestation:workload.Attested_By,
          Approved_Tier:workload.Workload_Status,
          Date_Approved:workload.AWS_Date_Approved,
          SFDC_Status:workload.SFDC_Sales_Stage, //SFDC Sales Stage 
          Notes:workload.AWS_Notes,
          Creator_Name: workload.Contact_FullName,
          Creator_Email:workload.Contact_Email,
          Date_Created:workload.Date_Created
        }

        let workloadStatus = [
          'Approved - Tier 1 23% - PPA'
         ,'Approved - Tier 3 12%'
         ,'Approved - Tier 2 - Custom EDP'
         ,'Disqualified - AWS forecast conflict'
         ,'Shareshift'
         ,'Disqualified - Incomplete'
         ,'Disqualified - No AWS scope'
       ]
       if(!workloadStatus.includes(workload.Workload_Status)){
         state.report = {
           ...state.report, 
           Date_Approved: ''
         }
       }
      }
      
      
      state.workloadLists1.push(state.report)
    });
    
    // state.newOppRegistration = { ...state.newOppRegistration, ...data }
  },
  showWorkloadSearching (state, data) {
    state.newOppRegistration = { ...state.newOppRegistration, ...data }
  },
  clearAwsReport (state) {
    state.workloadLists1= []
  },
  resetNewOppRegistration (state) {
    console.log('resetNewOppRegistration')
    state.newOppRegistration = {
      searching: false,
      opportunityFound: false,
      showWorkloadForm: false,
      type: 'new'
    }
    // state.workloadList = [] 
    // state.adminReportWorkloadList = [] 
  },
  resetAdminReportWorkloadList (state) {
    console.log('resetNewOppRegistration')
    state.newOppRegistration = {
      searching: false,
      opportunityFound: false,
      showWorkloadForm: false,
      type: 'new'
    }
    // state.workloadList = [] 
    state.adminReportWorkloadList = []
  },

  setOpportunityFound (state, id) {
    state.newOppRegistration = { ...state.newOppRegistration, opportunityFound: true, opportunityId: id }
  },
  setEmailButtonStatus (state) {
    let approvedStatus = ['Approved - Tier 1 23% - PPA', 'Approved - Tier 3 12%','Approved - Tier 2 - Custom EDP']
    if (approvedStatus.includes(state.workload.aws.OppReg_Status)) {
      if (state.workload.aws.AWS_SalesRep_Name !== null && state.workload.aws.AWS_SalesRep_eMail !== null) {
        if (state.workload.aws.AWS_SalesRep_Name !== '' && state.workload.aws.AWS_SalesRep_eMail !== '') {
          
          state.sendEmailStatus = true
        } else {
          state.sendEmailStatus = false
        }
      } else {
        state.sendEmailStatus = false
      }
     
    } else {
      if (state.workload.aws.OppReg_Status !== '' || state.workload.aws.AWS_SalesRep_Name !== '' || state.workload.aws.AWS_SalesRep_eMail !== '') {
        
        state.sendEmailStatus = true
      } else {
        state.sendEmailStatus = false
      }
    }
  },
  clearQuestionnaireNextAnswers (state, order) {
    if (order === 1) {
      state.newWorkload.wlqa.WL_Q2A = null
    }
    // clear other answers
    state.newWorkload.wlqa.WL_Q3A = null
    state.newWorkload.wlqa.WL_Q4A = null
    state.newWorkload.wlqa.Attested_By = null
    state.newWorkload.wlqa.WL_Q5A = null
    state.newWorkload.wlqa.WL_Q6A = null
  },
  updateContactInfo (state, contact) {
    state.workload.contact.Id = contact.Id
    state.workload.contact.Contact_First_Name = contact.Contact_First_Name
    state.workload.contact.Contact_Last_Name = contact.Contact_Last_Name
    state.workload.contact.Contact_Email = contact.Contact_Email
    state.workload.contact.Contact_Phone = contact.Contact_Phone
    state.workload.contact.Contact_Title = contact.Contact_Title
    state.workload.contact.Contact_FullName = `${contact.Contact_Last_Name}, ${contact.Contact_First_Name}`
  },

  updateOpportunityInfo (state, opportunity) {
    state.workload.opportunity = {
      ...state.workload.opportunity,
      ...opportunity
    }
  },


  clearUpdateDialog: (state) => {
    state.workload = {
      opportunityNumber: '',
      opportunityNumberExistError: false,
      opportunityNumberExistErrorMessages: [],
      opportunityNumberExistSuccess: false,
      opportunityNumberExistSuccessMessages: [],
      opportunityNumberExistLoading: false
    }
  },

  setOpportunityNumberAvailabilityMessage (state, data) {
    if (data.type === 'success') {
      state.workload = {
        ...state.workload,
        opportunityNumberExist: true,
        opportunityNumberExistSuccess: true,
        opportunityNumberExistSuccessMessages: [data.message],
        opportunityNumberExistError: false,
        opportunityNumberExistErrorMessages: [],
        isOpportunityNumberExist: data.isExist
      }
    } else {
      state.workload = {
        ...state.workload,
        opportunityNumberExist: false,
        opportunityNumberExistSuccess: false,
        opportunityNumberExistSuccessMessages: [],
        opportunityNumberExistError: true,
        opportunityNumberExistErrorMessages: [data.message],
        isOpportunityNumberExist: data.isExist
      }
      // state.existingOnboardingAccount = {
      //   AcctSecurity_Id: data.record.AcctSecurity_Id, 
      //   Acct_Exp_Id:data.record.Acct_Exp_Id, 
      //   Acct_ID: data.record.Acct_ID, 
      //   Financial_Id: data.record.Financial_Id, 
      //   Onboarding_Id: data.record.Onboarding_Id, 
      //   Unique_Agreement_Id: data.record.Unique_Agreement_Id
      // }
    }
  },

  setOpportunityNumberExistLoading (state, loading) {
    if (loading) {
      state.workload = {
        ...state.workload,
        opportunityNumberExist: false,
        opportunityNumberExistLoading: loading,
        opportunityNumberExistError: false,
        opportunityNumberExistErrorMessages: [],
        opportunityNumberExistSuccess: false,
        opportunityNumberExistSuccessMessages: []
      }
    } else {
      state.workload = {
        ...state.workload,
        opportunityNumberExistLoading: loading
      }
    }
  },

  clearDiscountAnswers (state) {
    state.newWorkload.oppproject = {
      ...state.newWorkload.oppproject,
      Q8: null,
      Q9: null,
      Q10: null,
      Attested_By_Date: null,
      Attested_By_Email: null,
      Attested_By_Title: null,
      Attested_By_Manager: null
    }
  },
  clearDiscountTier2Answers (state) {
    state.newWorkload.oppproject = {
      ...state.newWorkload.oppproject,
      // Discount_Tier_On_AWS: null,
      Pricing_Tier_Qualification: null,
      Attested_By_Date: null,
      Attested_By_Email: null,
      Attested_By_Title: null,
      Attested_By_Manager: null
    }
  },
  setLoadingData (state, data) {
    state.loadingData = data
  },
  setAdminNextPageKey (state, data) {
    console.log('setAdminNextPageKey', data)
    state.adminNextPageKey = data
  },
  setNextArchivedPageKey (state, data) {
    state.nextArchivedPageKey = data
  },
  setAdminWorkloadList (state, data) {
    if (state.adminNextPageKey) {
      state.adminWorkloadList = [
        ...state.adminWorkloadList,
        ...data
      ]
    } else {
      state.adminWorkloadList = data
    }
  },
  setAdminReportNextPageKey (state, data) {
    state.adminReportNextPageKey = data
  },
  clearAdminWorkloadList (state, data) {
    console.log('clearAdminWorkloadList')
    state.adminWorkloadList = []
  },
  clearAdminNextPageKey (state, data) {
    state.adminNextPageKey = ''
  },
  clearNextArchivedPageKey (state, data) {
    state.nextArchivedPageKey = ''
  },
  clearAdminReportWorkloadList (state, data) {
    console.log('clearAdminReportWorkloadList')
    state.adminReportWorkloadList = []
  }
}
